import * as FetchAction from '../../actions/FetchAction';
import { endpoint } from '../../helpers/Endpoints';
import type { IProductRestriction } from '../../values';

export const SEARCH_PRODUCT_NUMBER_SUPPLIER_ID =
	'@ra:SEARCH_PRODUCT_NUMBER_SUPPLIER_ID';
export const SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_SUCCESS =
	'@ra:SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_SUCCESS';
export const SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_ERROR =
	'@ra:SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_ERROR';

export function lookUpProductsBySupplierId(
	productNumbers: string[],
	supplierId: number
) {
	const body = JSON.stringify({ productNumbers, supplierId });
	return FetchAction.CreateFetchAction({
		startAction: SEARCH_PRODUCT_NUMBER_SUPPLIER_ID,
		method: 'POST',
		body,
		url: endpoint.products(),
	});
}

export const MAXIMUM_RESTRICTIONS_EXCEEDED =
	'@ra:MAXIMUM_RESTRICTIONS_EXCEEDED';
export function maximumRestrictionsExceeded(
	isExceeded: boolean,
	productNumbers?: number
) {
	return {
		type: MAXIMUM_RESTRICTIONS_EXCEEDED,
		payload: { isExceeded, productNumbers },
	};
}

export const RESET_PRODUCT_VALIDATION_AND_LOOKUP =
	'@ra:RESET_PRODUCT_VALIDATION_AND_LOOKUP';
export function resetProductValidationAndLookup() {
	return {
		type: RESET_PRODUCT_VALIDATION_AND_LOOKUP,
	};
}

export const ENABLE_RESTRICT_BUTTON = '@ra:ENABLE_RESTRICT_BUTTON';
export function enableRestrictButton(isEnabled: boolean) {
	return {
		type: ENABLE_RESTRICT_BUTTON,
		payload: { isEnabled },
	};
}

export const SHOW_REMOVE_MODAL = '@ra:SHOW_REMOVE_MODAL';
export function showRemoveFromMogModal(isEnabled: boolean) {
	return {
		type: SHOW_REMOVE_MODAL,
		payload: { isEnabled },
	};
}

export const CLOSE_REMOVE_MODAL = '@ra:CLOSE_REMOVE_MODAL';
export function closeRemoveFromMogModal(isEnabled: boolean) {
	return {
		type: CLOSE_REMOVE_MODAL,
		payload: { isEnabled },
	};
}

export const RESTRICT_PRODUCTS = '@ra:RESTRICT_PRODUCTS';
export const RESTRICT_PRODUCTS_SUCCESS = '@ra:RESTRICT_PRODUCTS_SUCCESS';
export const RESTRICT_PRODUCTS_ERROR = '@ra:RESTRICT_PRODUCTS_ERROR';
export function restrictProducts(
	productRestrictions: IProductRestriction[],
	removeFromBlueprints: boolean
) {
	const body = JSON.stringify({ productRestrictions, removeFromBlueprints });

	return FetchAction.CreateFetchAction({
		url: endpoint.restrictProducts(),
		method: 'POST',
		body,
		startAction: RESTRICT_PRODUCTS,
		startActionPayload: true,
	});
}

export const RESET_ISSUCCESSFULLYADDED = '@ra:RESET_ISSUCCESSFULLYADDED';
export function resetIsSucessfullyAdded() {
	return {
		type: RESET_ISSUCCESSFULLYADDED,
	};
}
export const UPDATE_DEFAULT_RESTRICTION_MESSAGE =
	'@ra:UPDATE_DEFAULT_RESTRICTION_MESSAGE';

export function updateDefaultRestrictionMessage(newMessage: string) {
	return {
		type: UPDATE_DEFAULT_RESTRICTION_MESSAGE,
		payload: {
			newMessage,
		},
	};
}
